// this file added by Bearer Web Developer
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog } from '@mui/material';
import styles from './createAccountPopup.module.scss';
import StepOne from './stepOne';
import { useAppState } from '../../states/app-state';
import StepTwo from './stepTwo';
import EndStep from './endStep';
import { useThemeMode } from '../../states/contexts/theme';

interface Props {
    open: boolean
}

const CreateAccountPopup: React.FunctionComponent<Props> = observer(({ open }) => {
    const appState = useAppState();
    const { createAccount, accountVerification } = appState;
    const { step } = createAccount
    const handleClose = () => {
        if (step === 2) {
            if (createAccount?.complete_registeration) accountVerification?.setOpen(true);
            createAccount?.setOpen(false);
        } else {
            if (createAccount?.complete_registeration) return;
            createAccount?.setOpen(false);
        }
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <Dialog open={open}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                    },
                    classes: { root: step === 2 ? styles.end_step_root : styles.root }
                },
            }}
            classes={{ paperWidthSm: step === 2 ? styles.paper_width_sm : undefined }}
            onClose={handleClose}>
            <div className={styles.main_content}>
                {step === 0 ? <StepOne /> : step === 1 ? <StepTwo /> : <EndStep />}
            </div>
        </Dialog>
    );
});

export default CreateAccountPopup;
